module.exports = __webpack_public_path__ + "static/templates/bulk-upload-id.1EnaYwi.xlsx";